(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Testimonial-Slider"] && !window.DesignMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  const track = document.getElementById("testimonialTrack");
  const dots = document.querySelectorAll("#testimonialDots span");
  const slides = document.querySelectorAll(".testimonial-slide");
  const arrowPrev = document.getElementById("arrowPrev");
  const arrowNext = document.getElementById("arrowNext");

  const isMobile = window.innerWidth <= 768;
  const perView = isMobile ? 1 : 2;
  const totalGroups = Math.ceil(slides.length / perView);

  let current = 0;
  let interval;

  function goToSlide(index) {
    const offset = -(index * 100 / perView);
    track.style.transform = `translateX(${offset}%)`;
    dots.forEach(dot => dot.classList.remove("active"));
    if (dots[index]) dots[index].classList.add("active");
    current = index;
  }

  function startAutoSlide() {
    interval = setInterval(() => {
      current = (current + 1) % totalGroups;
      goToSlide(current);
    }, 5000);
  }

  function resetAutoSlide() {
    clearInterval(interval);
    startAutoSlide();
  }

  // Dot click
  dots.forEach((dot, i) => {
    dot.addEventListener("click", () => {
      goToSlide(i);
      resetAutoSlide();
    });
  });

  // Arrow click
  if (arrowPrev && arrowNext) {
    arrowPrev.addEventListener("click", () => {
      if (current > 0) {
        goToSlide(current - 1);
        resetAutoSlide();
      }
    });

    arrowNext.addEventListener("click", () => {
      if (current < totalGroups - 1) {
        goToSlide(current + 1);
        resetAutoSlide();
      }
    });
  }

  // Touch swipe
  let startX = 0;
  let endX = 0;

  track.addEventListener("touchstart", e => startX = e.touches[0].clientX);
  track.addEventListener("touchmove", e => endX = e.touches[0].clientX);
  track.addEventListener("touchend", () => {
    const diffX = endX - startX;
    if (Math.abs(diffX) > 50) {
      if (diffX < 0 && current < totalGroups - 1) goToSlide(current + 1);
      else if (diffX > 0 && current > 0) goToSlide(current - 1);
      resetAutoSlide();
    }
    startX = 0;
    endX = 0;
  });

  goToSlide(current);
  startAutoSlide();
});

  } catch(e) { console.error(e); }
})();
})();
